import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { EmailMessage } from '../types';

type EmailMessageStore = {
  messages: Record<string, EmailMessage>;
  actions: {
    updateMessage: (
      messageId: string,
      messageData: Partial<EmailMessage>,
    ) => void;
  };
};

const LOCAL_STORAGE_KEY = 'wg-email-messages';

const INITIAL_VALUES: Omit<EmailMessageStore, 'actions'> = Object.freeze({
  messages: {},
});

const useMessagesStore = create<EmailMessageStore>()(
  persist(
    (set, get) => ({
      ...INITIAL_VALUES,

      actions: {
        updateMessage: (
          messageId: string,
          emailData: Partial<EmailMessage>,
        ) => {
          const currentValue = get().messages?.[messageId] ?? { messageId };
          const newValue = {
            ...currentValue,
            ...emailData,
          };

          set((state) => ({
            ...state,
            messages: {
              ...state.messages,
              [messageId]: newValue,
            },
          }));
        },
      },
    }),
    {
      name: LOCAL_STORAGE_KEY,
      version: 1,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      partialize: ({ actions, ...rest }) => rest,
    },
  ),
);

export default useMessagesStore;
